import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import AbsentIcon from 'components/icons/AbsentIcon'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'
import HoldtocompareIcon from 'components/icons/HoldtocompareIcon'
import SelectTickIcon from 'components/icons/SelectTickIcon'
import { Wrapper } from 'modules/Roles/Partials/RolesFilter/Styles/style'
import React from 'react'
const StatusFilter = ({ statusFilter, setStatusFilter }) => {
  const options2 = [
    {
      label: 'To be updated',
      value: 'TO_BE_UPDATED',
    },
    {
      label: (
        <div>
          <SelectTickIcon /> &nbsp;&nbsp;{' '}
          <span style={{ position: 'relative', top: '-6px' }}>
            Move to next round
          </span>{' '}
        </div>
      ),
      value: 'MOVE_TO_NEXT_ROUND',
    },
    {
      label: (
        <div>
          <HoldtocompareIcon /> &nbsp;&nbsp;{' '}
          <span style={{ position: 'relative', top: '-6px' }}>
            Hold to compare
          </span>{' '}
        </div>
      ),
      value: 'HOLD_TO_COMPARE',
    },
    {
      label: (
        <div>
          <AbsentIcon /> &nbsp;&nbsp;{' '}
          <span style={{ position: 'relative', top: '-6px' }}>Absent</span>{' '}
        </div>
      ),
      value: 'ABSENT',
    },
    {
      label: (
        <div>
          <RejectIcon /> &nbsp;&nbsp;{' '}
          <span style={{ position: 'relative', top: '-6px' }}>Reject</span>{' '}
        </div>
      ),
      value: 'REJECT',
    },
  ]

  const onStatusChange = values => {
    setStatusFilter(values)
  }

  return (
    <Wrapper>
      <FilterCheckBoxComp
        value={statusFilter}
        options={options2}
        onChange={onStatusChange}
        valueParam="value"
        labelParam="label"
        showFromStart
      />
    </Wrapper>
  )
}

export default StatusFilter
